import { render, staticRenderFns } from "./VisorHelp.vue?vue&type=template&id=3459b72f&scoped=true&"
import script from "./VisorHelp.vue?vue&type=script&lang=js&"
export * from "./VisorHelp.vue?vue&type=script&lang=js&"
import style1 from "./VisorHelp.vue?vue&type=style&index=1&id=3459b72f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459b72f",
  null
  
)

export default component.exports